// NOTE This is a view/model.  Has to dynamically track references so they can be annotated properly
// Is the view that renders the References page, but is also updated by the other pages anytime they render
// an annotated referenct.
import pdfPageTitle from './PDFPageTitle';

const circleSvg = d3.create('svg');
circleSvg.attr('viewBox', '0 0 10 10');
// bulletSvg.style('stroke', '#ff0000');
circleSvg.append('circle')
    .attr('cx', 5)
    .attr('cy', 5)
    .attr('r', 5)
    .attr('fill', '#777777');

// TODO: references, additionalReferences should just be in the PDF Model, and this view should just be instantiated using that model, instead of using 'reset'.
const references = [];
let pageNumber = 0;
let model = [];
export default {
    add: (text) => {
        let index = references.indexOf(text) + 1;
        if (index <= 0) {
            references.push(text);
            index = references.length;
        }

        return { index, text };
    },
    reset: (pdfModel) => {
        references.length = 0;
        model = pdfModel;
    },
    get pageNumber() {
        return pageNumber;
    },
    page: {
        container: true,
        optional: false,
        references: {
            newPage: true,
            // debug: true,
            title: 'References',
            page: () => {
                const page = pdfPageTitle({ title: 'References', colorClass: 'print.dark' });
                for (let i = 0; i < model.additionalReferences.length; i++) {
                    page[`additionalRef${i + 1}`] = {
                        mt: 3,
                        bullet: {
                            w: 10,
                            h: 10,
                            circle: {
                                w: 4,
                                h: 4,
                                mt: 1,
                                svg: circleSvg.node()
                            }
                        },
                        ref: {
                            display: 'inline',
                            text: `${model.additionalReferences[i]}`
                        }
                    };
                }
                return page;
            }
        },
        dataSources: {
            newPage: true,
            // debug: true,
            title: 'Data Sources',
            page: ({ num }) => {
                pageNumber = num;
                const page = pdfPageTitle({ title: 'Data Sources', colorClass: 'print.dark' });
                for (let i = 0; i < references.length; i++) {
                    page[`ref${i + 1}`] = {
                        mt: 6,
                        text: `${i + 1}. ${references[i]}`
                    };
                }
                return page;
            }
        }
    }
};
